module.exports = __webpack_public_path__ + "media/public/images/slider/banner_desktop-3574d29cd12de8f5c3cdd73efe1c11f4.png";